import React from 'react';


const ImagesContext = React.createContext();

export default ImagesContext;
